export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6913.ac42b324.jpg";